<template>
    <div v-if="show">
        <v-form ref="form" v-model="validForm" lazy-validation>
            <v-row>
                <!-- Start Table Solutions -->
                <v-data-table :headers="filteredHeaders" :items="list" :items-per-page="12" class="elevation-1"
                    style="width: 100%">
                    <template v-slot:top>
                        <v-toolbar flat class="rounded-lg">
                            <v-toolbar-title>Históricos</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn :disabled="disabled" color="primary" class="mb-2" text @click="() => create()">
                                <v-icon>add</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </template>

                    <!-- Customizar apenas as colunas específicas -->
                    <template v-slot:item.month="{ item }">
                        <span style="font-size: 17px;">{{ item.monthFormatted }}</span>
                    </template>

                    <template v-slot:item.water="{ item }">
                        <span style="font-size: 17px;">{{ item.water }} m³</span>
                    </template>

                    <template v-slot:item.sewer="{ item }">
                        <span style="font-size: 17px;">{{ item.sewer }} m³</span>
                    </template>

                    <template v-slot:item.consumptionTotal="{ item }">
                        <span style="font-size: 17px;">{{ item.consumptionTotal }} m³</span>
                    </template>

                    <template v-slot:item.consumptionType="{ item }">
                        <div style="font-size: 14px; line-height: 1.4;">
                            <div><strong>Água:</strong> {{ item.consumptionTypeWater }}</div>
                            <div><strong>Esgoto:</strong> {{ item.consumptionTypeSewer }}</div>
                        </div>
                    </template>

                    <template v-slot:item.hasLeak="{ item }">
                        <span style="font-size: 17px;">{{ item.hasLeak ? 'Sim' : 'Não' }}</span>
                    </template>

                    <template v-slot:item.accountAmount="{ item }">
                        <span style="font-size: 17px;">{{ formatCurrencyValue(item.accountAmount) }}</span>
                    </template>

                    <template v-slot:item.file="{ item }">
                        <div style="font-size: 14px; text-align: center;">
                            <v-btn 
                                v-if="item.path_file_photo_account"
                                icon
                                small
                                color="primary"
                                :disabled="disabled"
                                @click="() => downloadFileFromList(item)"
                            >
                                <v-icon small>mdi-file-pdf-box</v-icon>
                            </v-btn>
                            <span v-else class="grey--text text--lighten-1">
                                <v-icon small color="grey lighten-1">mdi-file-remove</v-icon>
                            </span>
                        </div>
                    </template>

                    <template v-slot:item.action="{ item }">
                        <v-btn elevation="2" @click="() => confirmDeleteSolution(item, list.indexOf(item))"
                            style="height: 30px; margin: 2px" :disabled="disabled" :loading="loading"
                            :disaled="loading">
                            <v-icon color="primary" small> mdi-delete </v-icon>
                        </v-btn>
                        <v-btn elevation="2" @click="() => edit(item)" :disabled="disabled"
                            style="height: 30px; margin: 2px" :loading="loadingIndex === list.indexOf(item)" :disaled="loadingIndex === list.indexOf(item)">
                            <v-icon color="primary" small> mdi-pencil </v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
                <!-- End Table Solutions -->
            </v-row>
            <v-dialog transition="dialog-top-transition" v-model="dialog" v-if="dialog" persistent max-width="500px">
                <v-card>
                    <v-toolbar color="primary" dark> <span class="text-h5">Adicionar Histórico</span></v-toolbar>
                    <v-card-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text style="padding-bottom: 0px;">
                        <v-row>
                            <v-col cols="12">
                                <date-picker-dialog title="Escolha o mês do histórico" type="month"
                                    :show="datePickerDialog" @close="(status) => (datePickerDialog = status)"
                                    :input="dateMonth" @change="(newDate) => confirmDatePicker(newDate)"
                                    :rules="rulesRequired" :loading="loading || savingLoading" :disaled="loading || savingLoading" />
                                <v-text-field label="Mês" v-model="historic.monthFormatted" readonly
                                    @click="openDataDialog()" :rules="rulesRequired" :loading="loading || savingLoading"
                                    :disaled="loading || savingLoading">
                                </v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field label="Água" type="Number" v-model="historic.water" suffix="m³"
                                    @change="sumWaterAndSewer()" :loading="loading || savingLoading"
                                    :disaled="loading || savingLoading" />
                            </v-col>
                            <v-col cols="4">
                                <v-text-field label="Esgoto" type="Number" v-model="historic.sewer" suffix="m³"
                                    @change="sumWaterAndSewer()" :loading="loading || savingLoading"
                                    :disaled="loading || savingLoading" />
                            </v-col>
                            <v-col cols="4">
                                <v-text-field label="Consumo Total" v-model="historic.consumptionTotal" suffix="m³"
                                    disabled :rules="rulesRequired" :loading="loading || savingLoading" :disaled="loading || savingLoading" />
                            </v-col>
                            <v-col cols="6">
                                <v-select label="Tipo do Cons. da Água" :items="consumptionType"
                                    v-model="historic.consumptionTypeWater" :rules="rulesRequired" :loading="loading || savingLoading"
                                    :disaled="loading || savingLoading" />
                            </v-col>
                            <v-col cols="6">
                                <v-select label="Tipo do Cons. do Esgoto" :items="consumptionType"
                                    v-model="historic.consumptionTypeSewer" :rules="rulesRequired" :loading="loading || savingLoading"
                                    :disaled="loading || savingLoading" />
                            </v-col>
                            <v-col v-if="showLeakField" cols="12">
                                <v-checkbox
                                    v-model="historic.hasLeak"
                                    label="Houve vazamento neste mês?"
                                    :loading="loading || savingLoading"
                                    :disabled="loading || savingLoading"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field type="number" prefix="R$" label="Valor da Conta"
                                    v-model="historic.accountAmount" @change="removeLeftZeroAndFormatCurrency()" :rules="rulesRequired" :loading="loading || savingLoading"
                                    :disabled="loading || savingLoading" />
                            </v-col>
                            <v-col cols="12">
                                <InputFiles 
                                    title="Adicionar PDF da Conta do Mês"
                                    :fileTypes="['pdf']"
                                    :showFile="historic.file_photo_account"
                                    :required="false"
                                    :disabled="loading || savingLoading"
                                    @change:file="handleFileChange" 
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="() => closeDialog()" :loading="savingLoading"
                            :disabled="savingLoading">
                            Cancelar
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="() => save()" :loading="savingLoading" :disabled="savingLoading">
                            Salvar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-form>
    </div>
</template>

<script>

import DatePickerDialog from "@/components/DatePickerDialog/DatePickerDialog.vue";
import InputFiles from "@/components/Forms/Input/input-files.vue";
import { showErrorSnackBar, showSuccessSnackBar } from "@/utils/SnackBartHelper"
import { showDeleteDialogAlert } from "@/utils/DialogAlertHelper";
import cloneDeep from 'lodash/cloneDeep';

import Rules from "@/utils/Rules";
import Utils from '@/scripts/Utils';
import HistoricStorage from "@/services/storage/HistoricStorage";

const newHistoric = () => {
    return {
        accountAmount: 0,
        consumptionTotal: 0,
        consumptionTypeSewer: null,
        consumptionTypeWater: null,
        month: null,
        monthFormatted: null,
        sewer: 0,
        water: 0,
        hasLeak: false,
        // Campos para arquivo da conta
        file_photo_account: null,           // Arquivo temporário (File object)
        path_file_photo_account: null,      // Caminho no Storage
        file_photo_account_name: null,      // Nome original do arquivo
    }
}

export default {
    name: "SharedHistoricList",

    components: {
        DatePickerDialog,
        InputFiles,
    },

    props: {
        show: {
            type: Boolean,
            default: true
        },
        list: {
            type: Array,
            default: () => ([]),
        },
        add: {
            type: Function,
            default: (hydrometer, index) => { }
        },
        remove: {
            type: Function,
            default: (index) => { }
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        showLeakField: {
            type: Boolean,
            default: true
        },
    },

    data: () => ({
        validForm: true,
        dialog: false,
        loading: false,
        savingLoading: false,
        loadingIndex: null,
        index: -1,
        historic: newHistoric(),
        consumptionType: [
            "Real",
            "Fixo",
            "Const Cort",
            "Estimado",
            "Informado",
            "Media HD",
            "Min Fixed",
        ],
        headers: [
            { text: "Mês", value: "month", width: 180, sortable: true },
            { text: "Água", value: "water", sortable: true },
            { text: "Esgoto", value: "sewer", sortable: true },
            { text: "Total", value: "consumptionTotal", sortable: true },
            { text: "Tipo Consumo", width: 150, value: "consumptionType", sortable: false },
            { text: "Vazamento", value: "hasLeak", width: 100, showIf: 'showLeakField', sortable: true },
            { text: "Conta (R$) ", value: "accountAmount", sortable: true },
            { text: "Arquivo", value: "file", width: 120, sortable: false },
            { text: "Ações ", value: "action", sortable: false },
        ],
        datePickerDialog: false,
        dateMonth: null,
    }),

    computed: {
        rulesRequired() {
            return Rules.required();
        },
        filteredHeaders() {
            return this.headers.filter(header => {
                if (header.showIf === 'showLeakField') {
                    return this.showLeakField;
                }
                return true;
            });
        },
    },

    methods: {
        formatCurrencyValue(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(value);
        },
        create() {
            this.index = -1
            this.historic = newHistoric()
            this.dialog = true
        },
        async edit(item) {
            // Encontrar o índice real do item na lista
            const index = this.list.findIndex(h => h === item);
            
            // Validar se o item foi encontrado
            if (index === -1 || !this.list[index]) {
                console.error("Item não encontrado na lista:", item);
                showErrorSnackBar("Erro ao abrir histórico. Tente novamente.");
                return;
            }
            
            this.index = index
            this.historic = cloneDeep(this.list[index])
            
            // Validar se o histórico foi clonado corretamente
            if (!this.historic) {
                console.error("Erro ao clonar histórico");
                showErrorSnackBar("Erro ao carregar dados do histórico.");
                return;
            }
            
            // Se existe arquivo anexado, fazer download para exibir no InputFiles
            if (this.historic.path_file_photo_account && !this.historic.file_photo_account) {
                try {
                    this.loadingIndex = index;
                    const blob = await HistoricStorage.downloadFile(this.historic.path_file_photo_account);
                    
                    // Converter Blob para File para o InputFiles exibir corretamente
                    const fileName = this.historic.file_photo_account_name || 'conta.pdf';
                    const file = new File([blob], fileName, { type: 'application/pdf' });
                    
                    this.historic.file_photo_account = file;
                } catch (error) {
                    console.error("Erro ao carregar arquivo para edição:", error);
                    // Continua sem o arquivo se der erro
                } finally {
                    this.loadingIndex = null;
                }
            }
            
            this.dialog = true
        },
        async save() {
            if (!this.$refs.form.validate()) {
                return
            }

            this.savingLoading = true;

            try {
                // Se há arquivo novo para fazer upload ou arquivo para deletar
                // E estamos editando um histórico existente (tem id_doc)
                if ((this.historic.file_photo_account || this.historic._shouldDeleteFile) && this.historic.id_doc) {
                    // Buscar dados antigos
                    const oldHistoric = this.list[this.index];
                    
                    // Se há novo arquivo, fazer upload
                    if (this.historic.file_photo_account) {
                        // Deletar arquivo antigo se existir
                        if (oldHistoric?.path_file_photo_account) {
                            try {
                                await HistoricStorage.deleteFile(oldHistoric.path_file_photo_account);
                            } catch (deleteErr) {
                                console.error("Erro ao deletar arquivo antigo:", deleteErr);
                            }
                        }
                        
                        // Upload do novo arquivo
                        try {
                            const filePath = await HistoricStorage.uploadFile(
                                this.historic.id_project, 
                                this.historic.id_doc, 
                                this.historic.file_photo_account
                            );
                            
                            this.historic.path_file_photo_account = filePath;
                            this.historic.file_photo_account_name = this.historic.file_photo_account.name;
                        } catch (uploadErr) {
                            console.error("Erro ao fazer upload:", uploadErr);
                            showErrorSnackBar("Erro ao fazer upload do arquivo");
                            this.savingLoading = false;
                            return; // Não salvar se o upload falhar
                        }
                    } else if (this.historic._shouldDeleteFile && oldHistoric?.path_file_photo_account) {
                        // Apenas deletar arquivo
                        try {
                            await HistoricStorage.deleteFile(oldHistoric.path_file_photo_account);
                            this.historic.path_file_photo_account = null;
                            this.historic.file_photo_account_name = null;
                        } catch (deleteErr) {
                            console.error("Erro ao deletar arquivo:", deleteErr);
                        }
                    }
                    
                    // Limpar campos temporários antes de salvar
                    const historicToSave = { ...this.historic };
                    delete historicToSave.file_photo_account;
                    delete historicToSave._shouldDeleteFile;
                    
                    await this.add(historicToSave, this.index);
                } else {
                    // Para novos históricos ou sem arquivo
                    // O upload será feito pelo HistoricService
                    // Aguardar conclusão para garantir que o arquivo seja salvo antes de fechar
                    await this.add({ ...this.historic }, this.index);
                }
                
                this.dialog = false;
            } catch (error) {
                console.error("Erro ao salvar histórico:", error);
                showErrorSnackBar("Erro ao salvar histórico");
            } finally {
                this.savingLoading = false;
            }
        },
        closeDialog() {
            this.dialog = false
        },
        openDataDialog() {
            this.datePickerDialog = true;
        },
        handleFileChange(file) {
            // Se o arquivo foi removido (null ou undefined)
            if (!file) {
                // Marcar que o arquivo antigo deve ser deletado
                this.historic._shouldDeleteFile = !!this.historic.path_file_photo_account;
                
                // Limpar os campos relacionados
                this.historic.file_photo_account = null;
                this.historic.path_file_photo_account = null;
                this.historic.file_photo_account_name = null;
            } else {
                // Arquivo novo foi adicionado
                this.historic.file_photo_account = file;
                
                // Se havia um arquivo antigo, marcar para deletar
                if (this.historic.path_file_photo_account) {
                    this.historic._shouldDeleteFile = true;
                }
            }
        },
        confirmDatePicker(newMonth) {
            let hasMonth = false
            if (this.list.length > 0) {
                let checkMonth = this.list.filter(
                    ({ month }) => month == newMonth
                );
                if (checkMonth.length > 0) {
                    hasMonth = true
                    showErrorSnackBar(`O mês já selecionado. Por favor, selecione outro mês!`)
                }
            }
            if (!hasMonth) {
                this.historic.month = newMonth
                this.historic.monthFormatted = Utils.formatMonthDate(this.historic.month, "<MM> de <YYYY>", true)
            }
        },
        sumWaterAndSewer() {
            this.historic.water = parseFloat(this.historic.water)
            this.historic.sewer = parseFloat(this.historic.sewer || 0)
            this.historic.consumptionTotal = this.historic.water + this.historic.sewer
        },
        cleanCurrencyInput(input) {
            const cleanedInput = input.replace(/[^\d,]/g, '');
            return cleanedInput.replace(',', '.');
        },
        removeLeftZeroAndFormatCurrency() {
            this.historic.accountAmount = parseFloat(this.historic.accountAmount)
        },
        async confirmDeleteSolution(item, index) {
            showDeleteDialogAlert(`Deseja excluir o histórico referente ao mês de ${item.monthFormatted}?`, () => this.remove(index))
        },
        async downloadFileFromList(historic) {
            if (!historic.path_file_photo_account) return;
            
            try {
                const url = await HistoricStorage.getDownloadURL(historic.path_file_photo_account);
                
                // Abrir em nova aba
                window.open(url, '_blank');
                
                showSuccessSnackBar("Abrindo arquivo...");
            } catch (error) {
                console.error("Erro ao baixar arquivo:", error);
                showErrorSnackBar("Erro ao baixar o arquivo da conta");
            }
        },
    },
};
</script>

<style scoped></style>

